import { Navigate, Route, Routes } from 'react-router-dom';

import { Login } from './Login';
import { Register } from './Register';

export const AuthRoutes = () => {
  console.log("App Routes")
  return (
    <Routes>
      <Route path="register" element={<Register />} />
      <Route index path="login" element={<Login />} />
      <Route index path="*" element={<Navigate to="login" />} />
    </Routes>
  );
};
